import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DemoUserDto, UserDto, UsersDto } from '../models/User';
import { UserRoleDto, UserRolesDto } from '../models/Identity/UserRole';
import { UserClaimDto, UserClaimsDto } from '../models/Identity/UserClaim';
import { UserProviderDeleteDto, UserProvidersDto } from '../models/Identity/UserProviders';
import { UserChangePasswordDto } from '../models/Identity/UserChangePasswordDto';
import { RoleClaimsDto } from '../models/Identity/RoleClaim';
import { GenericFilter } from '../models/GenericFilter';
import { PlatformGroupRoleDto } from '../models/PlatformGroupRoleDto';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  
  constructor(private httpClient: HttpClient, private oauthService: OAuthServiceService) {
    super();
  }

  getUser(id: string): Observable<UserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserDto>(`${this.account}/${id}`, { headers: headers });
  }

  getUserById(id: string): Observable<UserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserDto>(`${this.account}/getUserById/${id}`, { headers: headers });
  }

  isConfirmationLeft(id: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.account}/isConfirmationLeft/${id}`);
  }

  // getUserPlatformGroupRole(id: string) : Observable<PlatformGroupRoleDto[]> {
  //   return this.httpClient.get<PlatformGroupRoleDto[]>(`${this.account}/${id}/PlatformUserRoles`);
  // }

  // getUserPlatformGroupRole(id: string) : Observable<any> {
  //   return this.httpClient.get<any>(`${this.account}/${id}/PlatformUserRoles`);
  // }

  // getUserRoles(id: string, page?: number, pageSize?: number): Observable<UserRolesDto> {
  //   return this.httpClient.get<UserRolesDto>(`${this.account}/${id}/UserRoles?page=${page}&pageSize=${pageSize}`);
  // }

  loadUsers(genericFilter: GenericFilter) : Observable<UserDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<UserDto[]>(`${this.account}/GetFilteredUsers?genericFilter=genericFilter`,genericFilter, { headers: headers });
  }

  // getAllUsers(searchText: string, page?: number, pageSize?: number): Observable<UsersDto> {
  //   return this.httpClient.get<UsersDto>(`${this.account}?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  // }

  getAllUsers(searchText: string, page?: number, pageSize?: number): Observable<UserDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserDto[]>(`${this.account}?searchText=${searchText}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  updateUser(userToUpdate: UserDto): Observable<UserDto> {
    // return this.httpClient.put<UserDto>(`${this.account}/${userToUpdate.id}`,userToUpdate);
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.put<UserDto>(`${this.account}`, userToUpdate, { headers: headers });
  }

  createUser(newUserProfile: UserDto, isTenantAdmin: boolean, copyUserId: string, tenantdb: string, tenantid: string): Observable<UserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    //console.log("calling ", `${this.account}/AddUser/${tenantdb}/${tenantid}/${copyUserId}`)
    return this.httpClient.post<UserDto>(`${this.account}/AddUser/${tenantdb}/${tenantid}/${isTenantAdmin}/${copyUserId}`, newUserProfile, { headers: headers });
  }

  createUserWithPermissions(isTenantAdmin: boolean, inclTGR: boolean, copyUserId: string, newUserProfile: UserDto, projRolePairs: string[], tenantdb: string, tenantid: string): Observable<UserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    //console.log("calling ", `${this.account}/AddUserWithPermissions/${tenantdb}/${tenantid}/${newUserProfile.email}`)
    return this.httpClient.post<UserDto>(`${this.account}/AddUserWithPermissions/${tenantdb}/${tenantid}/${newUserProfile.email}/${inclTGR}/${isTenantAdmin}/${copyUserId}`, projRolePairs, { headers: headers });
  }

  renewUser(isTenantAdmin: boolean, inclTGR: boolean, copyUserId: string, newUserProfile: UserDto, projRolePairs: string[], tenantdb: string, tenantid: string): Observable<UserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    //console.log("calling ", `${this.account}/AddUserWithPermissions/${tenantdb}/${tenantid}/${newUserProfile.email}`)
    return this.httpClient.post<UserDto>(`${this.account}/RenewUser/${tenantdb}/${tenantid}/${newUserProfile.email}/${inclTGR}/${isTenantAdmin}/${copyUserId}`, projRolePairs, { headers: headers });
  }

  createDemoUser(newUserProfile: DemoUserDto, tenantdb: string): Observable<DemoUserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<DemoUserDto>(`${this.account}/AddDemoUser/${tenantdb}`, newUserProfile, { headers: headers });
  }

  // deleteUser(id: string) : Observable<any> {
  //   const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
  //   return this.httpClient.delete<any>(`${this.account}/${id}`, { headers: headers });
  // }
 
  // getUserRoles(id: string, page?: number, pageSize?: number): Observable<UserRolesDto> {
  //   return this.httpClient.get<UserRolesDto>(`${this.account}/${id}/UserRoles?page=${page}&pageSize=${pageSize}`);
  // }

  // createUserRoles(userRoleDto: UserRoleDto) {
  //   return this.httpClient.post(`${this.account}/Roles`, userRoleDto);
  // }

  // deleteUserRoles(userRoleDto: UserRoleDto) {
  //   return this.httpClient.post(`${this.account}/Role`, userRoleDto);
  // }

  // getUserClaims(id: string, page?: number, pageSize?: number): Observable<UserClaimsDto> {
  //   return this.httpClient.get<UserClaimsDto>(`${this.account}/${id}/Claims?page=${page}&pageSize=${pageSize}`);
  // }

  // createUserClaims(userClaimDto: UserClaimDto) {
  //   return this.httpClient.post(`${this.account}/Claims`, userClaimDto);
  // }

  // updateUserClaims(userClaimDto: UserClaimDto) {
  //   return this.httpClient.put(`${this.account}/Claims`, userClaimDto);
  // }

  // deleteUserClaims(id: string, claimId: number) {
  //   return this.httpClient.delete(`${this.account}/${id}/Claims?claimId=${claimId}`);
  // }

  // getUserProviders(id: string): Observable<UserProvidersDto> {
  //   return this.httpClient.get<UserProvidersDto>(`${this.account}/${id}/Providers`);
  // }

  // deleteUserProviders(userProviderDeleteDto: UserProviderDeleteDto) {
  //   return this.httpClient.delete(`${this.account}/Providers`);
  // }

  changePassword(userChangePasswordDto: UserChangePasswordDto) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post(`${this.account}/ChangePassword`, userChangePasswordDto, { headers: headers });
  }

  // getRoleClaims(id: string, claimSearchText: string, page?: number, pageSize?: number): Observable<RoleClaimsDto> {
  //   return this.httpClient.get<RoleClaimsDto>(`${this.account}/${id}/RoleClaims?claimSearchText=${claimSearchText}&page=${page}&pageSize=${pageSize}`);
  // }

  // getClaimUsers(claimType: string, claimValue: string, page?: number, pageSize?: number): Observable<UsersDto> {
  //   return this.httpClient.get<UsersDto>(`${this.account}/ClaimType/${claimType}/ClaimValue/${claimValue}?page=${page}&pageSize=${pageSize}`);
  // }

  // getClaimWithUsers(claimType: string, page?: number, pageSize?: number): Observable<UsersDto> {
  //   return this.httpClient.get<UsersDto>(`${this.account}/ClaimType/${claimType}?page=${page}&pageSize=${pageSize}`);
  // }

}

